module.exports = __webpack_public_path__ + "static/media/bg-sobre-pedraza@2x.ac535549.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imagenes/sobrePedraza/bg-sobre-pedraza@2x.jpg
// module id = 121
// module chunks = 0